import { createAsyncThunk } from "@reduxjs/toolkit";
import { BaseApiResponse } from "common/types";
import { wrapRequest } from "common/utils";
import { dashboardService as service } from "services/serviceStorage";
import {
    StackReportDashboardRequest,
    StackReportDashboardResponse,
    StackReportLoadScenariosPayload,
    StackReportScenarioApiItem,
    StackReportScenarioFilter,
    StackReportScenarioOption,
} from "./types";
import { mapDashboardItem, StackReportDashboardItem } from "components/stackReport/utils";

const mapScenario = (item: StackReportScenarioApiItem): StackReportScenarioOption => ({
    key: item.scenarioId,
    displayName: item.scenarioName,
    state: item.state,
    startDate: new Date(item.startDate),
    endDate: new Date(item.endDate),
});

export const fetchScenarios = createAsyncThunk<StackReportScenarioOption[], StackReportScenarioFilter>(
    "stackReportDashboard/fetchScenarios",
    async (filter, { rejectWithValue }) => {
        const { data, errors, warnings } = await wrapRequest<BaseApiResponse<StackReportScenarioApiItem[]>>({
            handler: () => service.getScenarios(filter),
            showNotifications: true,
        });

        if (!data?.result) {
            return rejectWithValue({ errors, warnings });
        }

        return data.result.map(mapScenario);
    }
);

export const loadScenarios = createAsyncThunk<void, StackReportLoadScenariosPayload>(
    "stackReportDashboard/loadScenarios",
    async ({ scenarioIds, dashboardIds }, { rejectWithValue }) => {
        const err = await wrapRequest<BaseApiResponse<void>>({
            handler: () => service.loadScenarios({
                scenarioIds,
                dashboards: dashboardIds,
            }),
            showNotifications: true,
        });

        if (err.errors?.length || err.warnings?.length) {
            return rejectWithValue(err);
        }
    }
);

export const fetchDashboard = createAsyncThunk<StackReportDashboardItem, StackReportDashboardRequest>(
    "stackReportDashboard/fetchDashboard",
    async (request, { rejectWithValue }) => {
        const { data, errors, warnings } = await wrapRequest<BaseApiResponse<StackReportDashboardResponse>>({
            handler: () => service.getDashboard(request),
            showNotifications: true,
        });

        if (!data?.result) {
            return rejectWithValue({ errors, warnings });
        }

        return mapDashboardItem(data.result);
    }
);
